<template>
  <div class="opportunity-vote-tooltip-details">
    <span class="opportunity-vote-tooltip-details__name">{{ name }}</span>
    <span class="opportunity-vote-tooltip-details__type">{{ voteType }}</span>
    <span v-if="reasons" class="opportunity-vote-tooltip-details__reasons">{{ reasons }}</span>
  </div>
</template>

<script>
export default {
  name: 'OpportunityVoteTooltipDetails',
  props: {
    name: {
      type: String,
      required: true,
    },
    voteType: {
      type: String,
      required: true,
    },
    reasons: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.opportunity-vote-tooltip-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  &__name {
    font-weight: 600;
  }

  &__type {
    font-size: 11px;
    text-transform: capitalize;
  }

  &__reasons {
    font-size: 11px;
    opacity: 0.85;
    word-break: break-word;
  }
}
</style>
